export default __webpack_public_path__ + "static/media/banner2.090b08c3.png";